import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth-guard.service';
import { onboardingCompleteGuard, onboardingGuard } from './shared/guards/onboarding.guard';
import { healthGuard } from './shared/services/health/health-guard.service';

export const appRoutes: Routes = [
  {
    path: '',
    canActivate: [authGuard, onboardingGuard, healthGuard],
    loadChildren: () => import('./core/layout/layout.routes').then((m) => m.layoutRoutes),
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./features/auth/onboarding/onboardingSteps').then((m) => m.OnboardingSteps),
    canActivate: [authGuard, onboardingCompleteGuard, healthGuard],
  },
  {
    path: 'maintenance',
    loadComponent: () => import('./features/maintenance/maintenance').then((m) => m.Maintenance),
  },

  {
    path: '**',
    redirectTo: '',
  },
];
